import { render, staticRenderFns } from "./purchaser.vue?vue&type=template&id=72ec3d9d&scoped=true&"
import script from "./purchaser.vue?vue&type=script&lang=js&"
export * from "./purchaser.vue?vue&type=script&lang=js&"
import style0 from "./purchaser.vue?vue&type=style&index=0&id=72ec3d9d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ec3d9d",
  null
  
)

export default component.exports